var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCareHistoryMensIrregularitiesVisit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 28
    },
    viewBox: "0 0 37 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.123 16.781a.686.686 0 1 1-1.1-.82c.25-.335.682-.9 1.296-1.694a.686.686 0 0 1 1.07-.018c2.672 3.234 4.015 5.6 4.015 7.227 0 2.5-2.035 4.524-4.543 4.524s-4.542-2.025-4.542-4.524c0-.896.4-1.99 1.18-3.313a.686.686 0 1 1 1.18.696c-.666 1.131-.989 2.015-.989 2.617a3.162 3.162 0 0 0 3.171 3.152 3.162 3.162 0 0 0 3.171-3.152c0-1.107-1.048-3.036-3.157-5.684a98.71 98.71 0 0 0-.752.99Zm-1.747 4.762a.686.686 0 0 1 1.371 0c0 .568.46 1.028 1.029 1.028a.686.686 0 0 1 0 1.372 2.4 2.4 0 0 1-2.4-2.4Z",
    fill: "#FFAE2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.758 18.303a.601.601 0 0 0-.849 0l-3.288 3.288a12.3 12.3 0 0 1 20.894-10.288.6.6 0 1 0 .849-.849A13.502 13.502 0 0 0 5.39 21.422l-3.118-3.118a.6.6 0 0 0-.849.848l4.243 4.243a.602.602 0 0 0 .848 0l4.243-4.242a.601.601 0 0 0 0-.849ZM32.245 18.579l3.119 3.118a.6.6 0 0 0 .848-.849l-4.242-4.242a.602.602 0 0 0-.849 0l-4.242 4.242a.6.6 0 0 0 .848.849l3.288-3.288a12.3 12.3 0 0 1-20.894 10.288.6.6 0 0 0-.848.848A13.502 13.502 0 0 0 32.245 18.58Z",
    fill: "#FFAE2D",
    stroke: "#FFAE2D",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCareHistoryMensIrregularitiesVisit);
export default __webpack_public_path__ + "static/media/icon_care_history_mens_irregularities_visit.cecb4ccb2e4bfaa6be3696f00d1a2c6a.svg";
export { ForwardRef as ReactComponent };